import { render, staticRenderFns } from "./DelayDeleteModal.vue?vue&type=template&id=261abbee"
import script from "./DelayDeleteModal.vue?vue&type=script&lang=js"
export * from "./DelayDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports